import { orderBy } from '@progress/kendo-data-query';
import { useAppDispatch } from "../../redux/store";
import { setButtonsState } from "../../redux/features/appStateSlice";
import { FunctionComponent } from "react";
import { GridDataItem, useDashboardContext, ViewMode } from "./dashboardContext";
import { Grid, GridColumn, GridNoRecords, GridRowClickEvent } from "@progress/kendo-react-grid";
import { UrlParams } from "../../constante/UrlParams";
import { useNavigate } from "react-router";
import { planogramme } from "../../constante/routes";


export const DashboardGrid: FunctionComponent = () => {
    const dispatch = useAppDispatch();
    const {
        currentView,
        title,
        gridItems,
        selectedSection,
        selectedDivision,
        selectedMagasin,
        sections,
        dashboardData,
        gridSort,
        setGridSort,
    } = useDashboardContext();
    const navigate = useNavigate();

    const handleRowClick = (ev: GridRowClickEvent) => {
        const item = ev.dataItem as GridDataItem;
        if (currentView === ViewMode.STORE) {
            const section = sections.find(s => s.plans_nom === item.name);

            if (!section || !selectedMagasin || !selectedDivision) return;
            const searchParams = new URLSearchParams();
            searchParams.set(UrlParams.Magasin, selectedMagasin.mag_num.toString());
            searchParams.set(UrlParams.Section, section.plans_seq.toString());
            searchParams.set(UrlParams.Division, selectedDivision.div_num.toString());

            searchParams.set(UrlParams.Statut, "SortirPL,SurPlancher,Vendu");
            dispatch(setButtonsState({
                storeView: false,
                productView: true,
            }));
            navigate(`${planogramme}?${searchParams.toString()}`);
        } else {
            const magasin = dashboardData[0].sectionStores?.find((s: any) => s.magasin?.mag_nom_aff === item.name)?.magasin;
            if (!magasin || !selectedSection || !selectedDivision) return;

            const searchParams = new URLSearchParams();
            searchParams.set(UrlParams.Magasin, magasin.mag_num.toString());
            searchParams.set(UrlParams.Section, selectedSection.plans_seq.toString());
            searchParams.set(UrlParams.Division, selectedDivision.div_num.toString());

            searchParams.set(UrlParams.Statut, "SortirPL,SurPlancher,Vendu");
            dispatch(setButtonsState({
                storeView: true,
                productView: false,
            }));
            navigate(`${planogramme}?${searchParams.toString()}`);
        }
    };

    return (
        <Grid
            data={orderBy(gridItems, gridSort)}
            onRowClick={handleRowClick}
            sortable={true}
            resizable={true}
            reorderable={true}
            sort={gridSort}
            onSortChange={(e) => {
                setGridSort(e.sort);
            }}
            style={{
                width: "100%",
            }}
        >
            <GridNoRecords>
                Aucun enregistrement disponible.
            </GridNoRecords>
            <GridColumn
                title={title}
                field={"name"}
                resizable={true}
                reorderable={true}
            />
            <GridColumn
                title="Qté sur le plancher"
                field="nombreReel"
                headerClassName="alignRight"
                className="alignRight"
                width={"150px"}
                minResizableWidth={150}
                resizable={true}
                reorderable={true}
            />
            <GridColumn
                title="Qté visée"
                field="nombreVise"
                headerClassName="alignRight"
                className="alignRight"
                width={"150px"}
                minResizableWidth={150}
                resizable={true}
                reorderable={true}
            />
        </Grid>
    );
};

export default DashboardGrid;